import { Button, Divider, Grid, Paper, Rating, Typography } from '@mui/material'
import React from 'react'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import DuoIcon from '@mui/icons-material/Duo';
import VedioCallIcon from '../../../images/VedioCallIcon.svg'
import CallIcon from '../../../images/CallIcon.svg'
import { useNavigate } from 'react-router-dom';
function ServiceCard({ service }) {
    const navigate = useNavigate();
    return (
        service != undefined
            ?
            <Paper sx={{ boxShadow: '0px 8px 64px rgba(54, 101, 208, 0.14)', py: 2 }}>
                <Grid container >
                    <Grid item md={8} sx={{ px: 2 }}>
                        <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%' }}>{service?.serviceName}</Typography>
                        <Rating readOnly precision={0.1} className='text1Bold' value={4.6} />
                        <Typography variant="body2" className='tex2Mid' sx={{ width: '100%', opacity: '0.5' }}>By {service?.coach?.fullName}</Typography>
                    </Grid>
                    <Grid item md={4} xs={12} sx={{ px: 3, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button
                            className='text2Mid'
                            sx={{
                                py: 1,
                                backgroundColor: '#2544EE',
                                borderRadius: '0.5rem',
                                color: '#fff',
                                border: '1px solid #2544EE',
                                '&:hover': {
                                    color: '#2544EE',
                                    backgroundColor: '#fff'
                                },
                            }}
                            endIcon={<ArrowForwardIosOutlinedIcon />}
                            onClick={() => navigate(`/candidate/featured-service/${service._id}`)}
                            variant="contained"
                        >
                            Apply
                        </Button >
                        <BookmarkBorderIcon sx={{ ml: 4 }} />
                    </Grid>
                    <Grid md={12} mx={3} my={2}>
                        <Divider sx={{ backgroundColor: '#000' }} />
                    </Grid>

                </Grid>

                <Grid container px={2} my={2}>
                    <Grid item md={4} xs={12}>
                        <Typography className='text1Mid'>
                            Special Price: <b>₹{service?.suggestedPrice}</b>
                        </Typography>
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <Typography className='text1Bold'>
                            Medium:
                            <img src={VedioCallIcon} alt='icon' style={{ marginLeft: '8px' }} />
                        </Typography>
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <Typography className='text1Mid'>
                            Duration: <b>{service?.totalDuration}</b>
                        </Typography>
                    </Grid>
                </Grid>

            </Paper>
            :
            <Paper sx={{ boxShadow: '0px 8px 64px rgba(54, 101, 208, 0.14)', py: 2 }}>
                <Grid container >
                    <Grid item md={8} sx={{ px: 2 }}>
                        <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%' }}>Adobe Photoshop Training For Beginner</Typography>
                        <Rating />
                        <Typography variant="body2" className='tex2Mid' sx={{ width: '100%', opacity: '0.5' }}>By Tisha Kakkar</Typography>
                    </Grid>
                    <Grid item md={4} xs={12} sx={{ px: 3, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button
                            className='text2Mid'
                            sx={{
                                py: 1,
                                backgroundColor: '#2544EE',
                                borderRadius: '0.5rem',
                                color: '#fff',
                                border: '1px solid #2544EE',
                                '&:hover': {
                                    color: '#2544EE',
                                    backgroundColor: '#fff'
                                },
                            }}
                            endIcon={<ArrowForwardIosOutlinedIcon />}
                            // onClick={handleSubmit}
                            variant="contained"
                        >
                            Apply
                        </Button >
                        <BookmarkBorderIcon sx={{ ml: 4 }} />
                    </Grid>
                    <Grid md={12} mx={3} my={2}>
                        <Divider sx={{ backgroundColor: '#000' }} />
                    </Grid>

                </Grid>

                <Grid container px={2} my={2}>
                    <Grid item md={4} xs={12}>
                        <Typography className='text1Mid'>
                            Special Price: <b>₹10k</b>
                        </Typography>
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <Typography className='text1Bold'>
                            Medium:
                            <img src={CallIcon} alt='icon' style={{ marginLeft: '8px' }} />
                            <img src={VedioCallIcon} alt='icon' style={{ marginLeft: '8px' }} />
                        </Typography>
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <Typography className='text1Mid'>
                            Duration: <b>1 Hour</b>
                        </Typography>
                    </Grid>
                </Grid>

            </Paper>
    )
}

export default ServiceCard